import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TSDViewHouseFormValues } from '@e-origin/contracts';

import { MultiLangCodes, TextInput } from '@components';
import { useCodeListSystem } from '@hooks/useCodeListSystem';

interface HousePersonProps {
  houseForm: UseFormReturnType<TSDViewHouseFormValues>;
  disabled: boolean;
  personTitle: string;
  personFieldBasePath: string;
}

export const HousePerson: React.FC<HousePersonProps> = ({ houseForm, disabled, personTitle, personFieldBasePath }) => {
  const getInputProps = (field) => houseForm.getInputProps(`${personFieldBasePath}.${field}`);
  const codelistSystems = useCodeListSystem({});

  return (
    <Stack mb="sm">
      <Title order={5} fw={600}>
        {personTitle}
      </Title>

      <Grid>
        <Grid.Col span={4}>
          <TextInput {...getInputProps('identificationNumber')} label="Identification Number" disabled={disabled} />
        </Grid.Col>

        <Grid.Col span={5}>
          <TextInput {...getInputProps('name')} label="Name" disabled={disabled} />
        </Grid.Col>

        <Grid.Col span={3}>
          <MultiLangCodes {...getInputProps('typeOfPerson')} label="Type of person" code="CL729" system={codelistSystems} disabled={disabled} />
        </Grid.Col>
      </Grid>

      <Stack>
        <Title order={6} fw={600}>
          {personTitle} address
        </Title>

        <Grid>
          <Grid.Col span={5}>
            <TextInput {...getInputProps('address.street')} label="Street" disabled={disabled} />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput {...getInputProps('address.streetAdditionalLine')} label="Street additional line" disabled={disabled} />
          </Grid.Col>
          <Grid.Col span={3}>
            <TextInput {...getInputProps('address.number')} label="House number" disabled={disabled} />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col span={4}>
            <TextInput {...getInputProps('address.poBox')} label="PO Box" disabled={disabled} />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput {...getInputProps('address.subDivision')} label="Sub-division" disabled={disabled} />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col span={4}>
            <MultiLangCodes {...getInputProps('address.country')} label="Country" code="CL199" disabled={disabled} system={codelistSystems} searchable />
          </Grid.Col>
          <Grid.Col span={3}>
            <TextInput {...getInputProps('address.postcode')} label="Post code" disabled={disabled} />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput {...getInputProps('address.city')} label="City" disabled={disabled} />
          </Grid.Col>
        </Grid>
      </Stack>

      <Stack>
        <Title order={6} fw={600}>
          {personTitle} communication
        </Title>

        <Grid>
          <Grid.Col span={4}>
            <TextInput {...getInputProps('communication.phoneNumber')} label="Phone number" disabled={disabled} />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput {...getInputProps('communication.eMailAddress')} label="Email address" disabled={disabled} />
          </Grid.Col>
        </Grid>
      </Stack>
    </Stack>
  );
};
